import {UserModel} from '../../shared/model/users/UserModel.js';
import {GigyaModel} from '../../shared/model/GigyaModel';
import {FarmModel} from '../../shared/model/farms/FarmModel.js';
import {FieldCollection} from '../../shared/collection/farms/FieldCollection.js';
import {CropSeasonCollection} from '../../shared/collection/farms/CropSeasonCollection.js';
import {SessionStorageUtil} from '../../shared/utils/SessionStorageUtil';
import {CropCollection} from '../../shared/collection/md/CropCollection';
import {StressCollection} from '../../shared/collection/md/StressCollection';
import {FarmFeatures2Collection} from '../../shared/collection/users/FarmFeatures2Collection';
import {AppFeaturesModel} from '../../shared/model/app-features/AppFeaturesModel';
import {FarmCollection} from '../../shared/collection/farms/FarmCollection';
import { localStorageFilterKey as CFD_FILTER_LOCAL_STORAGE_KEY_GENERAL } from '../../layout/CrossFarmDashboardLayout/Filters/GroupViews/GeneralFilterGroupView/GeneralFilterGroupState';
import { localStorageFilterKey as CFD_FILTER_LOCAL_STORAGE_KEY_RISK } from '../../layout/CrossFarmDashboardLayout/Filters/GroupViews/RiskFilterGroupView/RiskFilterGroupState';
import { localStorageFilterKey as CFD_FILTER_LOCAL_STORAGE_KEY_TASK } from '../../layout/CrossFarmDashboardLayout/Filters/GroupViews/TaskFilterGroupView/TaskFilterGroupState';

export const GIGYA = new GigyaModel();
export const CURRENT_USER = new UserModel();
export const FARMS = new FarmCollection();
export const CURRENT_FARM = new FarmModel();
export const CURRENT_FIELDS = new FieldCollection();
export const CURRENT_CROP_SEASONS = new CropSeasonCollection();
export const CROPS = new CropCollection();
export const STRESSES = new StressCollection();
export const CURRENT_FARM_FEATURES = new FarmFeatures2Collection();
export const APP_FEATURES = new AppFeaturesModel({}, {CURRENT_USER});

export function expire () {

    CURRENT_USER.renew();
    FARMS.reset();
    CURRENT_FARM.clear();
    CURRENT_FIELDS.reset();
    CURRENT_FIELDS.farmUuid = undefined;
    CURRENT_CROP_SEASONS.dropFilterParams();
    CROPS.reset();
    STRESSES.reset();
    CURRENT_FARM_FEATURES.reset();
    SessionStorageUtil.clear();
    APP_FEATURES.renew();

    // Clear Shop selection
    localStorage.removeItem('SHOP_PACKAGE_UUIDS');
    localStorage.removeItem('SHOP_VOUCHER');

    // Clear Cross farm dashboard filters 
    localStorage.removeItem(CFD_FILTER_LOCAL_STORAGE_KEY_GENERAL);
    localStorage.removeItem(CFD_FILTER_LOCAL_STORAGE_KEY_RISK);
    localStorage.removeItem(CFD_FILTER_LOCAL_STORAGE_KEY_TASK);

    // New stack CFD Filter
    localStorage.removeItem('CFD_FILTER_STATE');
}



// WEBPACK FOOTER //
// ./js/resources/SessionObjects.js